import { useReducer, useEffect, createContext } from "react";

export const ErrorsValue = createContext();
export const ErrorsDisbatch = createContext();

const reducer = (state, action) => {
  const newState = { ...state };
  switch (action.type) {
    case "setErrorsForBlock":
      const elementErrors = [...newState.elements].filter(
        (x) => x.blockId !== action.blockId
      );
      return { ...newState, elements: [...elementErrors, ...action.value] };
    case "setErrorsForWorkflow":
      return { ...newState, workflows: [...action.value] };
    case "setElements":
      return { ...newState, elements: action.value };
    case "setUtilties":
      return { ...newState, utilities: action.value };
    case "setWorkflows":
      return { ...newState, workflows: action.value };
    default:
      return newState;
  }
};

export default function ErrorsContext({ children }) {
  const [state, dispatch] = useReducer(reducer, {
    elements: [],
    workflows: [],
    utilities: [],
  });
  return (
    <ErrorsValue.Provider value={state}>
      <ErrorsDisbatch.Provider value={dispatch}>
        {children}
      </ErrorsDisbatch.Provider>
    </ErrorsValue.Provider>
  );
}
